<!--  -->
<template>
  <div class="i-swiper">
    <el-carousel ref="carousel" class="carousel" height="520px" :autoplay="false" indicator-position="none">
      <el-carousel-item v-for="item in imgList" :key="item">
        <el-image class="el-carousel-img" :src="item" :preview-src-list="imgList" fit="cover"></el-image>
        <div class="slot-z-100">
          <slot />
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="img-list">
      <div class="list-item" v-for="(item, index) in imgList" :key="item" @click="handleChangeIndex(index)">
        <el-image class="list-item-img" :src="item" fit="cover"></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    imgList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      initialIndex: 0,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleChangeIndex(index) {
      this.$refs.carousel.setActiveItem(index);
    },
  },
};
</script>
<style lang="scss" scoped>
.i-swiper {
  width: 520px;
  .el-carousel-img {
    width: 100%;
    height: 520px;
  }
  .img-list {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 18px;
    .list-item {
      margin-right: 10px;
      cursor: pointer;
      &:last-child .list-item-img {
        margin-right: 0;
      }
    }
    .list-item-img {
      width: 98px;
      height: 98px;
    }
  }
}
.i-swiper .carousel {
  position: relative;
}
.slot-z-100 {
  position: absolute;
  z-index: 100;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
